import { OwnerType } from "@/db/definitions";
import { createHash } from "crypto";

export const getContentChecksum = (content: string) => {
  const checksum = createHash("sha256").update(content).digest("base64");

  return checksum;
};

export const createSlug = (name?: string): string => {
  return (name || "")
    .toLowerCase() // Convert to lowercase
    .trim() // Remove leading/trailing spaces
    .replace(/[\s_]+/g, "-") // Replace spaces and underscores with dashes
    .replace(/[^\w-]+/g, "") // Remove non-alphanumeric characters except dashes
    .replace(/--+/g, "-") // Replace multiple dashes with a single dash
    .replace(/^-+|-+$/g, ""); // Remove leading or trailing dashes
};

export const getOwnerHref = (type: OwnerType, slug: string) => {
  return `/owner/${type.toLocaleLowerCase()}/${slug}`;
};

export const getOwnerCityListingsHref = (
  type: OwnerType,
  ownerSlug: string,
  citySlug: string,
) => `${getOwnerHref(type, ownerSlug)}/listings/${citySlug}`;

export const getListingHref = (city: string, slug: string | null) => {
  return `/rent/${createSlug(city)}/${slug}`;
};

export const capitalize = (text: string): string => {
  return text.charAt(0).toUpperCase() + text.slice(1);
};

export const fixAIUrlString = (url: string) => {
  const markdownLinkRegex = /\[([^\]]+)\]\(([^)]+)\)/;
  const match = url.match(markdownLinkRegex);
  if (match) {
    // If it is a markdown link, return the URL part
    return match[2];
  }
  return url;
};

export const getTranslationTextId = (value: string, prefix = ""): string => {
  const slug = createSlug(value);
  if (prefix) {
    if (slug.endsWith("-")) {
      return `${prefix}${slug}`;
    }

    return `${prefix}-${slug}`;
  }

  return slug;
};

export const stableJsonStringify = (value: unknown): string => {
  if (value instanceof Date) {
    return JSON.stringify(value.toISOString());
  }

  if (Array.isArray(value)) {
    return `[${value.map(stableJsonStringify).join(",")}]`;
  }

  if (value && typeof value === "object") {
    const obj = value as Record<string, unknown>;
    const keys = Object.keys(obj).sort();

    return `{${keys
      .map((k) => `${JSON.stringify(k)}:${stableJsonStringify(obj[k])}`)
      .join(",")}}`;
  }

  return JSON.stringify(value);
};
